export default __webpack_public_path__ + "static/media/lemon_logo.45849607.svg";